import { CIMSPageItem } from '../CIMSPageItem'
import { Concrete } from '../../CIMSModule/instances'
import { Notifications } from '.'

export const ConcreteTestSets = new CIMSPageItem({
  id: '5734d949-50e9-4984-b801-18226ff50683',
  deprecatedPathnames: ['break-form'],
  name: 'Concrete Test Sets',
  pathname: 'test-sets',
  module: Concrete,
  linkable: true,
})
export const DocumentChecklists = new CIMSPageItem({
  id: '5b1be5a5-4116-4edb-bca0-ede960df258b',
  name: 'Document Checklists',
  pathname: 'document-checklists',
  module: Concrete,
})
export const ConcreteTestingLabs = new CIMSPageItem({
  id: '3888dde4-0abb-4025-800f-bca9f7a1fefb',
  name: 'Testing Labs',
  pathname: 'testing-labs',
  module: Concrete,
})
export const ConcreteNotifications = Notifications({
  id: '43db961e-024c-49f3-b554-fe4ce441cc5e',
  module: Concrete,
})
export type ConcretePageItem =
  | typeof ConcreteTestSets
  | typeof DocumentChecklists
  | typeof ConcreteTestingLabs
  | typeof ConcreteNotifications
